import * as types from '../actions/actionTypes';

let initialState = {
    reconciliationReports: {
        loading: false,
        success: true,
        data: {
            reports: [],
            lastReconciliation: null,
            currentReconciliationBalance: 0,
            years: [],
            reconciliationInProgressReportId: null
        }
    },
    reconciliationReportDetails: {
        loading: false,
        success: true,
        newReconciliationReportId: null,
        data: {}
    },
    newReconciliationReport: {
        loading: false,
        success: true,
        newReconciliationReportId: null
    },   
    inProgressReconciliationReport: {
        loading: false,
        success: true
    },
    deleteReconciliationReport: {
        loading: false,
        success: true,
    },
    reconciliationAdjustments: [],
    reconciliationBalance: 0,
    filters: {
        year: ''
    }
};

export default function reconciliationReportsReducer(state = initialState, action) {
    switch (action.type) {

        case types.START_GET_BANK_RECONCILIATIONS:
            return { ...state, reconciliationReports: { ...initialState.reconciliationReports, loading: true } };
        
        case types.GET_BANK_RECONCILIATIONS:
            return { ...state, reconciliationReports: { ...state.reconciliationReports, ...action.response }, reconciliationBalance: action.response.success ? action.response.data.currentReconciliationBalance : 0 };

        case types.UPDATE_RECONCILIATION_REPORTS_FILTERS:
            return { ...state, filters: { ...state.filters, ...action.filter }};

        case types.UPDATE_RECONCILIATION_ADJUSTMENTS:
            return { ...state, reconciliationAdjustments: action.value };

        case types.UPDATE_RECONCILIATION_BALANCE:
            return { ...state, reconciliationBalance: action.value };

        case types.START_GET_RECONCILIATION_REPORT:
            return { ...state, reconciliationReportDetails: { ...initialState.reconciliationReportDetails, loading: true } };

        case types.GET_RECONCILIATION_REPORT:
            return { ...state, reconciliationReportDetails: { ...action.response } }; 

        case types.START_CREATE_RECONCILIATION_REPORT:
            return { ...state, newReconciliationReport: { ...initialState.newReconciliationReport, loading: true } };

        case types.CREATE_RECONCILIATION_REPORT:
            return { ...state, newReconciliationReport: {...action.response, newReconciliationReportId: action.response.data } };
                
        case types.START_UPDATE_RECONCILIATION_REPORT:
        case types.START_COMPLETE_RECONCILIATION_REPORT:
        case types.START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT:
            return { ...state, inProgressReconciliationReport: { ...initialState.inProgressReconciliationReport, loading: true } };

        case types.UPDATE_RECONCILIATION_REPORT:
            return { ...state, inProgressReconciliationReport: { ...action.response } };

        case types.COMPLETE_RECONCILIATION_REPORT:
        case types.CREATE_AND_COMPLETE_RECONCILIATION_REPORT:
            return { ...state, reconciliationReports: initialState.reconciliationReports, newReconciliationReport: initialState.newReconciliationReport };

        case types.START_DELETE_RECONCILIATION_REPORT:
            return { ...state, deleteReconciliationReport: { ...initialState.deleteReconciliationReport, loading: true } };

        case types.DELETE_RECONCILIATION_REPORT:
            return { ...state, deleteReconciliationReport: { ...action.response }, newReconciliationReport: initialState.newReconciliationReport };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ReconciliationReportsReducer.js